import SwmsTemplates from './SwmsTemplates';
export default SwmsTemplates;
